import { createSlice } from '@reduxjs/toolkit';

const initialTheme = localStorage.getItem('theme') === 'dark';

const themeSlice = createSlice({
    name: 'theme',
    initialState: { isDarkMode: initialTheme },
    reducers: {
        toggleTheme(state) {
            state.isDarkMode = !state.isDarkMode;
            // Save the current theme in localStorage
            //console.log('save in local storage isDarkMode: ',state.isDarkMode);
            localStorage.setItem('theme', state.isDarkMode ? 'dark' : 'light');
        },
    },
});

export const { toggleTheme } = themeSlice.actions;
export default themeSlice.reducer;
